// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sectionTitle":"_2LC6vE","selectGroup":"a3dMyH","retirementAge":"_2gY6su","retirementAgeLabel":"_1bWrRy","link":"_3EtLqS","infoBtn":"_1ZObKL"};